import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Discussions.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import CommentList from './common/CommentList';
import User from './common/User';
import DiscussionLinks from './common/DiscussionLinks';
import DiscussionContent from './common/DiscussionContent';
import CommentOverlay from './common/CommentOverlay';
import ReplyOverlay from './common/ReplyOverlay';
import UserListOverlay from './common/UserListOverlay';
import ModerationOverlay from './common/ModerationOverlay';

const service = new Service();

class DiscussionsDetail extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let initialCommentData = [];
        let isMyAccountstate=0;
        this.totalCount = 0;
        let metaTitle = "Discussions on Pregnancy, Parenting, Baby Care & more";
        let metaDescription = [
            { "name": "description", "content": "Join the Firstcry Parenting discussions and be a part of one of the largest & active online communities. Discuss & stay updated on a host of useful & interesting topics." },
            { "name": "robots", "content": "all" }
        ]
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            let Ary = [];
            Ary.push(serverSideData['result']);
            initialData = Ary;
            initialCommentData = Ary[0]['comment'];
            this.totalCount = parseInt(initialData[0]['commentCount']);
        }
        if (initialData.length > 0) {
            metaTitle = actions.only_title(initialData[0].title) + " – FirstCry Parenting";
            metaDescription = [
                { "name": "description", "content": "Discuss & express your views on " + actions.only_title(initialData[0].title) + " at FirstCry Parenting." }
            ]
        }
        this.state = {
            initialData: initialData,
            commentData: initialCommentData,
            isCmtPage: false,
            metaTitle: metaTitle,
            metaDescription: metaDescription
        };

        this.dId = this.props.match.params.title.split('-').pop();
        this.disPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.disPageNo = parseInt(this.props.match.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;

        

    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var  isMyAccount=0;
          if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var dUrl = reqUrl.split('/')[3];
        var id = "";
        if (dUrl.includes('?')) {
            id = dUrl.split('?')[0].split('-').pop();
        } else {
            id = dUrl.split('-').pop();
        }

        if (dUrl.includes('me')) {
            var  isMyAccount=1;
        } 

        var url = global.api_url + "discussion/getdiscussiondetails";
        let body = JSON.stringify({
            "discussionId": id,
            "isMyAccount":isMyAccount
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    
    componentDidMount() {
        // if (this.props.location.search.includes('from=app')) {
        //     document.getElementsByClassName('write-comment')[0].style.bottom = '0';
        // }
        var isMyAccount=0;
       // var reqUrl=window.location.href;
        let reqUrl = this.props.match.url;

        console.log(reqUrl);
        // var dUrl = reqUrl.split('?')[1];
        // var DIDEqual=dUrl.split('&')[0];
        // var DId=DIDEqual.split('=')[1];
        if (reqUrl.includes('me')) {
              isMyAccount=1;
              this.setState({
                isMyAccountstate:isMyAccount
              })
        }
        
        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            this.checkPage();
            let size = 10;
            if (this.disPageNo > 1) {
                size = 10 * this.disPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.discussionData();
            } else {
                localStorage.setItem('discussionDetails_' + this.dId, JSON.stringify(this.state.initialData));
                actions.loadSliders();
            }
            if (!this.state.commentData || (this.state.commentData && this.state.commentData.length < 1)) {
                service.showLoader();
                this.commentData(1, size);
            } else {
                localStorage.setItem('discussionComments_' + this.dId, JSON.stringify(this.state.commentData));
                localStorage.setItem('discussionCommentsCnt_' + this.dId, JSON.stringify(this.totalCount));
            }
            actions.loadReadMore();
        } else {
            if (localStorage.getItem('discussionDetails_' + this.dId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('discussionDetails_' + this.dId)) }, () => { actions.loadSliders(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('discussionComments_' + this.dId)) {
                this.setState({ commentData: JSON.parse(localStorage.getItem('discussionComments_' + this.dId)) }, () => { actions.loadReadMore(); });
            }
            if (localStorage.getItem('discussionCommentsCnt_' + this.dId)) {
                this.totalCount = localStorage.getItem('discussionCommentsCnt_' + this.dId);
            }
            service.hideLoader();
        }
        actions.setWidth();
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            this.checkPage();
        });
    }

    componentWillUnmount() {
        this.unlisten();
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    checkPage() {
        this.url = new URL(window.location.href);
        if (this.url.searchParams.get("cid")) {
            this.setState({ isCmtPage: true });
            this.cid = this.url.searchParams.get("cid");
            this.pt = this.url.searchParams.get("pt");
        } else {
            this.setState({ isCmtPage: false }, () => { actions.loadSliders(); });
            this.cid = this.dId;
            this.pt = 0;
        }
    }

    appendURL() {
        if (this.state.isCmtPage) {
            this.props.history.push(service.getRedirectUrl("/discussions/t/" + this.props.match.params.title + "/page/" + this.disPageNo + "?cid=" + this.cid + "&pt=" + this.pt));
        } else {
            this.props.history.push(service.getRedirectUrl("/discussions/t/" + this.props.match.params.title + "/page/" + this.disPageNo));
        }
    }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('comment_container')[0]) {
                var cS = document.getElementsByClassName('comment_container')[0].offsetTop;
                var cH = document.getElementsByClassName('comment_container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.disPageNo;
                        service.showLoader();
                        service.showTracking();
                        _this.commentData(_this.disPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 1000)
    }

    discussionData() {
        var isMyAccount=0;
        var reqUrl=this.props.match.url;
        console.log("disc-",reqUrl);
        if(reqUrl.indexOf("?")>0)
        {
            var dUrl = reqUrl.split('?');
            var DIDEqual=dUrl.split('&')[0];
            var DId=DIDEqual.split('=')[1];
        }
        else
        {
            var DId=reqUrl.split('-')[1];
        }
      


         // let reqUrl = this.props.match.url;
         // var DId=reqUrl.split('=')[1];
        if (reqUrl.indexOf('me')>0) {
              isMyAccount=1;
        } 
         
        var postData = {
            "discussionId": this.dId
        }
        var url = global.api_ci_url + "Discussions/getdiscussiondetails";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                var dataAry = [];
                dataAry.push(json['result']);
                localStorage.setItem('discussionDetails_' + this.dId, JSON.stringify(dataAry));
                this.setState({ initialData: dataAry }, () => {  
                    //  service.loadImages(); actions.loadSliders(); actions.loadReadMore();
                     });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    commentData(pageno, size) {

        var isMyAccount=0;
      
        // var reqUrl=window.location.href;
        // var dUrl = reqUrl.split('?')[1];
        // var DIDEqual=dUrl.split('&')[0];
        // var DId=DIDEqual.split('=')[1];
        var reqUrl=this.props.match.url;
        console.log("disc-",reqUrl);
        if(reqUrl.indexOf("?")>0)
        {
            var dUrl = reqUrl.split('?');
            var DIDEqual=dUrl.split('&')[0];
            var DId=DIDEqual.split('=')[1];
        }
        else
        {
            var DId=reqUrl.split('-')[1];
        }
       
        if (reqUrl.indexOf('me')>0) {
            isMyAccount=1;
            this.setState({
                isMyAccountstate:1
            });
        } 
       
        var postData = {
            "recordId": this.cid,
            "postType": this.pt,
            "pageno": pageno,
            "pagesize": size,
            isMyAccount:isMyAccount
        }
        var url = global.api_ci_url + "Discussions/getcomment";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result'] && json['result'] != 'Record not found') {
                if (this.state.commentData.length > 0) {
                     if (size == (pageno * 10)) {
                            this.setState({ commentData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                        } else {
                            let ary = this.state.commentData;
                            this.setState({ commentData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadReadMore(); });
                        }
                    
                } else {
                    localStorage.setItem('discussionComments_' + this.dId, JSON.stringify(json['result']));
                    localStorage.setItem('discussionCommentsCnt_' + this.dId, JSON.stringify(json['totalComment']));
                    this.totalCount = parseInt(json['totalComment']);
                    this.setState({ commentData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    reloadData() {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            // var reqUrl=window.location.href;
            // var dUrl = reqUrl.split('?')[1];
            var reqUrl=this.props.match.url;
       
        if(reqUrl.indexOf("?")>0)
        {
            var dUrl = reqUrl.split('?');
          
        }
        else
        {
            var dUrl=reqUrl;
        }
          
            if (dUrl.indexOf('me')>0) {
                _this.discussionData();   
            } 
           
            _this.commentData(1, (1 * 10));
        }, 500);
        // console.log(document.querySelector(".comments_count_divider").offsetTop);
        window.scrollTo(0, document.querySelector(".comments_count_divider").offsetTop - 50);

    }

    render() {
        var mainDivStyle = {};
        if (this.state.isCmtPage) {
            mainDivStyle = {
                padding: 0
            }
        }
        return (
            <main className="discussions-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/discussions")} className="R11_9e">Discussions</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        {this.state.initialData && this.state.initialData[0] && !this.state.isCmtPage &&
                            <span>{actions.only_title(this.state.initialData[0].title)}</span>
                        }
                        {this.state.initialData && this.state.initialData[0] && this.state.isCmtPage &&
                            <span><Link to={service.getRedirectUrl(`/discussions/t/${service.replaceSymbols(actions.only_title(this.state.initialData[0].title) + '-' + (this.state.initialData[0].discussionId))}`)}>{actions.only_title(this.state.initialData[0].title)}</Link></span>
                        }
                    </div>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData.map((discussion, index) =>
                            <div key={index} className="discussion-block" id={`discussion_${discussion.discussionId}`} style={mainDivStyle}>
                                {!this.state.isCmtPage &&
                                    <a>
                                        <User user={discussion} isAnonymus={0} eleRef={this} />
                                    </a>
                                }
                                {!this.state.isCmtPage &&
                                    <DiscussionContent discussion={discussion} linkUrl={`/discussions/t/${service.replaceSymbols((actions.only_title(discussion.title)) + '-' + (discussion.discussionId))}`} isDisLanding={false} eleRef={this} />
                                }
                                {!this.state.isCmtPage &&
                                    <div className="divider_line"></div>
                                }
                                {!this.state.isCmtPage &&
                                    <DiscussionLinks discussion={discussion} eleRef={this} />
                                }
                                {!this.state.isCmtPage &&
                                    <div className="divider_line comments_count_divider">
                                        {discussion.commentCount < 1000 ?
                                            <div className="totalComment R13_42"> {discussion.commentCount} Comments </div>
                                            :
                                            <div className="totalComment R13_42"> {Number(((discussion.commentCount) / 1000).toFixed(1))}k Comments </div>
                                        }
                                    </div>
                                }
                                {this.state.commentData &&
                                    <CommentList  discussion={this.state.initialData} comments={this.state.commentData} isMyAccount={this.state.isMyAccountstate} eleRef={this} />
                                }
                            </div>
                        )}
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="discussion-block"></div>
                        }
                        <div className="write-comment">
                            <label>
                                {this.state.commentData && this.state.commentData.length > 0 ?
                                    <input type="text" placeholder="Write your comment here" onClick={() => actions.openParticipatePopup(this.state.initialData[0].discussionId, actions.only_title(this.state.initialData[0].title), this.state.initialData[0].discription, this.state.initialData[0].groupId, this.state.initialData[0].categoryId, this.state.initialData[0].urls && this.state.initialData[0].urls[0] ? this.state.initialData[0].urls[0].source : '')} readOnly />
                                    :
                                    <input type="text" placeholder="Be the first to comment" onClick={() => actions.openParticipatePopup(this.state.initialData[0].discussionId, actions.only_title(this.state.initialData[0].title), this.state.initialData[0].discription, this.state.initialData[0].groupId, this.state.initialData[0].categoryId, this.state.initialData[0].urls && this.state.initialData[0].urls[0] ? this.state.initialData[0].urls[0].source : '')} readOnly />
                                }
                            </label>
                            <div data-icon-font="o" className="icon comment-attachment"></div>
                            <div data-icon-font="&#xe00d;" className="icon submit-comment post_comment"></div>
                        </div>
                    </div>
                </div>
                <input type="hidden" id="post_commentId" value="" />
                <input type="hidden" id="post_parentUserId" value="" />
                <input type="hidden" id="post_parentUserName" value="" />
                <input type="hidden" id="post_parentIsAnonymus" value="" />
                <input type="hidden" id="post_replyId" value="" />
                <input type="hidden" id="post_dId" value="" />
                <input type="hidden" id="post_gId" value="" />
                <input type="hidden" id="post_cId" value="" />
                <input type="hidden" id="post_dUrl" value="" />
                <CommentOverlay eleRef={this} />
                <ReplyOverlay eleRef={this} />
                <UserListOverlay eleRef={this} />
                <div className="share-overlay"></div>
                <Right url={this.props.match.url} />
                <ModerationOverlay />
            </main>
        )
    }
}

export default DiscussionsDetail;



// WEBPACK FOOTER //
// src/shared/discussions/DiscussionsDetail.js